const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const BaseView = require('components-framework/view/base.view');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const initApplicationContext = require('./application.context');
const eventDispatcher = require('./event.dispatcher');

const NAME = 'conchita';
const TRANSLATION_PATH = '/service/templates/getConchitaKeysFromCMS?moduleName=';

const getModuleTranslationPath = (module) => `${TRANSLATION_PATH}${module}`;

const getTriggerNamespace = ({message}) => message ? `${NAME}:${message}` : NAME;

const triggerMessage = (data = {}) => Odigeo.trigger(getTriggerNamespace(data), data);

const getContext = ({
    trigger = () => {},
    basePath = '/',
    data = {},
} = {}) => initApplicationContext({dispatch: trigger, basePath, data});

module.exports = createWidgetFactory({
    name: NAME,
    viewClass: BaseView.extend({
        getContainer({container = ''}) {
            return document.querySelectorAll(`.${NAME}.${container}`);
        },
        render(params = {}) {
            this.renderIfContainerExists({...params, container: this.getContainer(params)});
        },
        renderIfContainerExists(params = {}) {
            const {container} = params;
            return container.length > 0
                ? this.renderContainers(params)
                : false;
        },
        renderContainers({
            container, component, translationPath, basePath,
            identifier, data, conchitaLiveContent, module,
        } = {}) {
            return container.forEach((c) => component({
                translationPath,
                container: c,
                applicationContext: getContext({trigger: triggerMessage, basePath, data}),
                conchitaLiveContent,
                tranlationModulePath: getModuleTranslationPath(module),
            }).then((root) => {
                eventDispatcher.subscribe({identifier, subscriber: root});
            }));
        },
    }),
    methods: {
        load(params = {}) {
            websiteConfigCollection.getLoadedPromise().then(() => this.render(params));
            return this;
        },
        dispatch({identifier = '', message = '', data = {}} = {}) {
            eventDispatcher.dispatch({identifier, message, data});
            return this;
        },
    },
    isEnabled() {
        return true;
    },
});
